import React from "react";
import Image from "react-bootstrap/Image";
import { NavLink } from "react-router-dom";

export const ReusableOnboardingButton = ({
  buttonType,
  buttonClass,
  buttonText,
  buttonTitle,
  onClick,
  disabled,
  buttonStyle,
}) => {
  return (
    <React.Fragment>
      <button
        type={buttonType}
        className={buttonClass}
        title={buttonTitle}
        onClick={onClick}
        style={buttonStyle}
        disabled={disabled === true ? { disabled } : false}
      >
        {buttonText}
      </button>
    </React.Fragment>
  );
};

export const ReusableOnboardingLink = ({
  link,
  buttonClass,
  buttonText,
  buttonTitle,
  onClick,
}) => {
  return (
    <React.Fragment>
      <NavLink
        to={link}
        className={buttonClass}
        title={buttonTitle}
        onClick={onClick}
      >
        {buttonText}
      </NavLink>
    </React.Fragment>
  );
};

export const ReusableOnboardingStepButton = ({
  buttonClass,
  buttonText,
  buttonTitle,
  onClickButton,
  buttonType,
}) => {
  return (
    <React.Fragment>
      <button
        onClick={onClickButton}
        className={buttonClass}
        title={buttonTitle}
        type={buttonType}
      >
        {buttonText}
      </button>
    </React.Fragment>
  );
};

export const ReusableOnboardingMapButton = ({
  displayRemove,
  displayPrimary,
  removeButtonClick,
  classsection,
  onClick,
  src,
  title,
  disabled,
  extraClass,
  extraPrimaryStyles,
  isSupported
}) => {
  return (
    <React.Fragment>
      <div
        className={`position-relative mt-3 col-md-4 col-6 mr-0 pr-0 ${extraClass}`}
      >
       
        <div
          className={classsection}
          style={{ cursor: disabled ? "no-drop" : "cursor" }}
          onClick={disabled ? () => {} : onClick}
        >
          {src ? <img src={src} alt="icon" title={title} /> : null}
          <span
            className="para-data-icon"
            style={displayPrimary ? { color: "#212121" } : { color: "#212121" }}
          >
            {title}
          </span>
        </div>
        {isSupported ? (
          <p
            className="primary-restaurant-type"
            style={{color:"green", ...extraPrimaryStyles }}
          >
            Supported
          </p>
        ) : (
          <p
            className="primary-restaurant-type"
            style={{ marginTop: "5px", ...extraPrimaryStyles }}
          >
            
          </p>
        )}
        {displayPrimary ? (
          <p
            className="primary-restaurant-type"
            style={{ marginTop: "5px", ...extraPrimaryStyles }}
          >
            Primary
          </p>
        ) : (
          ""
        )}
        {displayRemove === true ? (
          <div className="remove-button-css" onClick={removeButtonClick}>
            {/* <i className="fa fa-times font-awesome-icon" aria-hidden="true"></i> */}
            <Image
              src={require("../../../../assets/images/Icon/remove.png")}
              fluid
              className="remove-button-image"
            />
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
};

export const ReusableOnboardingPopupButtonMapButton = ({
  displayRemove,
  displayPrimary,
  removeButtonClick,
  classsection,
  onClick,
  src,
  title,
  disabled,
  extraClass,
  extraPrimaryStyles,
}) => {
  return (
    <React.Fragment>
      <div className={`position-relative mt-3 ${extraClass}`}>
        <div
          className={classsection}
          style={{ cursor: disabled ? "no-drop" : "cursor" }}
          onClick={disabled ? () => {} : onClick}
        >
          {src ? <img src={src} alt="icon" title={title} /> : null}
          <span
            className="para-data-icon"
            style={displayPrimary ? { color: "#212121" } : { color: "#212121" }}
          >
            {title}
          </span>
        </div>
        {displayPrimary ? (
          <p
            className="primary-restaurant-type"
            style={{ marginTop: "5px", ...extraPrimaryStyles }}
          >
            Primary
          </p>
        ) : (
          ""
        )}
        {displayRemove === true ? (
          <div className="remove-button-css" onClick={removeButtonClick}>
            {/* <i className="fa fa-times font-awesome-icon" aria-hidden="true"></i> */}
            <Image
              src={require("../../../../assets/images/Icon/remove.png")}
              fluid
              className="remove-button-image"
            />
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
};

export const ReusableOnboardingFaqButton = ({ onClick }) => {
  return (
    <React.Fragment>
      <div className="col-12 onboarding_process_screen_right-backbutton d-flex justify-content-end">
        <div
          style={{ cursor: "pointer" }}
          className="back_button-link d-none d-md-block d-lg-block d-xl-block"
        >
          <Image
            src={require("../../../../assets/images/Icon/help.png")}
            alt="FAQ Button"
            title="FAQ Button"
          />
        </div>
        <div style={{ cursor: "pointer" }} className="back_button-link ml-3">
          <Image
            src={require("../../../../assets/images/ActionImages/logout.svg")}
            alt="Logout"
            title="Logout"
            className="img-back"
            onClick={onClick}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
